import * as yup from 'yup';

export const IsoCodeValidationSchema = yup.object().shape({
	code: yup.string().required('Kod jest wymagany')
	.max(6, 'Kod może mieć maksymalnie 6 znaków'),
	name: yup.string().required('Nazwa jest wymagana')
	.max(150, 'Nazwa może mieć maksymalnie 150 znaków'),
	file: yup.object().required('Flaga kodu ISO języka nie może być pusta').nullable(),
});
